import { SharedLinkExpiration } from 'common/models/sharing';

const SHARED_LINK_EXPIRATION_LABELS = {
  [SharedLinkExpiration.ONE_CLICK]: { label: '1 Use' },
  [SharedLinkExpiration.ONE_DAY]: { label: '24 Hours' },
  [SharedLinkExpiration.NO_EXPIRATION]: { label: 'No Expiration' },
};

export default SHARED_LINK_EXPIRATION_LABELS;
